import axios from "axios";
import { api } from "~/router/apiConfig";

export function index(contractId, params = null) {
  return axios.get(
    api.path("contractBalanceOperationHistory.index", {
      contractId
    }),
    {
      params
    }
  );
}
